import React, {useState} from 'react';
import {Button, Checkbox} from '@blueprintjs/core';
import {useDispatch, useSelector} from "react-redux";
import {IconNames} from "@blueprintjs/icons";

import ConvertColumnDatatypeDialog from './ConvertColumnDatatypeDialog';
import {loadViewData} from "../../../store/actions/tableauActions";
import {IState} from "../../../store/reducers";
import {ApiStatus} from "../../../models";

import './ConvertColumnDatatype.scss';

type OnChangeCallback = (value: any) => void;

interface ConvertColumnDatatypeProps {
  columnProperties: any;
  onDataTypesChange: OnChangeCallback;
  onDataTypeParsingChange: OnChangeCallback;
  onWorkbookLocaleChange: OnChangeCallback;
  disabled: boolean;
  action: string;
  uid: string;
  integrationId: string;
  viewId: string;
  datatypeParsing: boolean;
  workbookLocale: string;
  isCSV: boolean;
}

export const ConvertColumnDatatype = ({
  columnProperties,
  onDataTypesChange,
  onDataTypeParsingChange,
  onWorkbookLocaleChange,
  disabled,
  action,
  uid,
  integrationId,
  viewId,
  datatypeParsing,
  workbookLocale,
  isCSV,
}: ConvertColumnDatatypeProps) => {
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  const viewDataLoading = useSelector((state: IState) => state.tableau.loadingViewDataStatus);
  const loading = viewDataLoading === ApiStatus.LOADING;

  const onClose = () => {
    setShow(false);
  }

  const onClick = () => {
    dispatch(loadViewData(uid as string, integrationId, viewId, action));
    setShow(true);
  }

  return (
    <div className="convert-column-datatype-container">
      <div className="convert-column-datatype-row">
        <div className="convert-column-datatype-label">Datatype Parsing</div>
        <Checkbox
          defaultChecked={datatypeParsing}
          onChange={onDataTypeParsingChange}
          disabled={disabled}
        />
        <Button
          text="Change Column Datatype"
          minimal={true}
          outlined={true}
          onClick={onClick}
          icon={IconNames.EDIT}
          intent={'primary'}
          loading={loading}
        />
      </div>
      {!loading && show && (
        <ConvertColumnDatatypeDialog
          columnProperties={columnProperties}
          show={show}
          onClose={onClose}
          onDataTypesChange={onDataTypesChange}
          disabled={disabled}
          isCSV={isCSV}
          workbookLocale={workbookLocale}
          onWorkbookLocaleChange={onWorkbookLocaleChange}
        />
      )
      }
    </div>
  );
}

export default ConvertColumnDatatype;
